"use strict";

class Accordian {
  constructor() {
    this.accordian = Array.prototype.slice.call( document.getElementsByClassName("btn-accordian") );
    this.events();
  }

  events() {
    if( this.accordian ) {
      this.accordian.forEach( panel => {
        panel.addEventListener( 'click', this.togglePanel );
      });  
    }
    
  }

  // methods
  togglePanel() {
    this.classList.toggle( "active" );
    var panel = this.nextElementSibling;

    if( panel.style.display === "block" ) {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  };

}

export default Accordian;